import type { PresenceDictionary } from '../wcContracts'

const presence: PresenceDictionary = {
  history: { title: '既有发布内容', body: '保留企业之前发布的内容与日期。打开原页面查看，不会重新发布。', publishedOn: '发布于 {date}', recordedPages: '条已记录的发布网址', receptionLoading: '正在读取接待设置…', receptionUnavailable: '暂时未能读取接待设置，已有网站内容仍可在下方查看。' },
  page: { title: '阵地', intro: '查看内容已经出现在哪里，并完成需要你处理的任务。' },
  overview: { officialSite: '官方网站', searchSubmission: '搜索收录提交', needsAction: '需要你处理', online: '在线', submitted: '已提交' },
  queue: { title: '内容任务队列', all: '全部', needsAction: '需要处理', inProgress: '处理中', published: '已发布', taskCount: '{count} 项任务' },
  state: { manualPrepared: '已准备人工步骤', reviewReady: '等待确认', processing: '处理中', published: '已发布' },
  manual: { title: '完成这次发布', noDuplicate: '没有产生重复发布。', fallbackBody: '自动发布没有完成，人工步骤已经准备好。', copy: '复制准备好的内容', openDestination: '打开目标平台', publicUrl: '发布后的公开网址', markPublished: '标记为已发布', saved: '已保存为发布完成。' },
  common: { websiteStatus: '网站状态', distribution: '分发', details: '发布详情', technicalRecord: '查看技术记录', demoData: '演示数据' },
  site: {
  "back": "网站列表",
  "switchSite": "切换网站",
  "single": "当前项目唯一网站",
  "navigation": "网站管理",
  "manage": "管理网站",
  "manageAirlock": "管理 Airlock",
  "pageCount": "个面向访客的页面",
  "viewPages": "查看页面",
  "todoCount": "{count} 项接待事项待处理",
  "languageBody": "网站内容语言由目标站点决定，不随界面语言切换。",
  "pagesBody": "这里列出当前站点版本的页面与可用接待形态；配置统一在 Airlock 中完成。",
  "noBuild": "还没有可读取的站点页面版本。站点生成并验真后，页面会显示在这里。",
  "machinePages": "机器可读文件",
  "readerPages": "访客页面",
  "machineNoSlot": "不安装接待界面",
  "noSlot": "尚无可安装位置",
  "originalTodo": "回到本次待办",
  "todoUnavailable": "原待办目前不可用，请查看此站点的最新事项。",
  "todoResolved": "这项待办已处理。",
  "todoOpen": "这项问题仍待处理，提交资料不会直接关闭它。",
  "domain": "网站地址",
  "environmentLabel": "发布环境",
  "installation": "连接方式",
  "connected": "已接入自动部署",
  "guided": "需要引导安装",
  "connectedBody": "通过已授权的站点连接执行发布；发布前仍会显示目标与影响范围。",
  "guidedBody": "该站点尚未接入受支持的自动部署方式。可在 Airlock 查看安装指引，不能在这里直接自动发布。",
  "deployBoundary": "浏览这里不会生成内容、部署或调用模型。",
  "unavailable": "所选网站不在当前可用阵地中。请返回网站列表选择，不会替你切换到另一网站。",
  "connect": "接入现有网站",
  "create": "创建新网站",
  "emptyBody": "先建立网站阵地，再启用 Airlock；不会为你猜测发布目标。",
  "connectHelp": "接入需要网站地址、管理授权和支持的连接方式。目前自助接站入口尚未开放，请由项目负责人完成站点配置后再继续。",
  "createHelp": "新站需要先确认内容与托管地址。目前自助建站入口尚未开放；站点配置完成后会出现在本列表中。",
  "tabs": {
    "overview": "总览",
    "pages": "页面与发布",
    "airlock": "Airlock",
    "deploy": "域名与部署"
  },
  "environment": {
    "production": "生产环境",
    "staging": "测试环境"
  },
  "airlockState": {
    "preparing": "正在准备",
    "ready": "可以启用",
    "publishing": "正在发布",
    "live": "接待中",
    "paused": "已暂停",
    "failed": "需要处理"
  },
  "slot": {
    "widget": "悬浮接待",
    "inline": "页面内接待",
    "focus": "专注接待"
  }
},
  material: {
  "pending_domain": "资料已提交，等待确认使用范围；尚未进入接待知识。",
  "awaiting_knowledge_confirmation": "已确认为公开资料，知识仍待整理与确认；尚未同步接待。",
  "private_only": "这份资料仅供内部使用，不能用于对外回答。你可以补充公开资料，或设置回答边界。",
  "synced": "公开资料已进入本项目的接待知识，可以返回 Airlock 重新测试。",
  "loadError": "暂时未能读取资料进度，不能据此判断资料未提交。请稍后重新打开。",
  "addMore": "继续补充资料"
},
  workspace: {
    loading: '正在读取已授权阵地…', error: '没有读到最新阵地状态。', empty: '当前还没有已授权阵地或完成验真的发布。', authorisedSites: '个已授权站点工作区', verifiedRoutes: '条已验真的线上路径', preservedIssues: '个已保留待处理问题', eyebrow: '站点工作区', title: '所有线上阵地与最近一次验真发布', siteCount: '{count} 个站点', mode: '站点模式', managedStatic: '领航者托管静态站点', languages: '支持语言', lastDeploy: '最近发布', machine: '机器层', noRelease: '这个站点还没有记录行动发布。',
    status: { configured: '已配置', building: '正在构建', ready: '可以发布', deploying: '正在部署', state_unknown: '状态需要验真', live: '在线', failed: '需要处理' }, machineStatus: { pending: '正在准备', verified: '已验证', unknown: '未知 · 已安全停下', failed: '失败' },
  },
}

export default presence
